import React, { useCallback, useRef, useLayoutEffect } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, CloseButton } from "components";
import { URLS } from "globalConstants";
import { isSessionExpired, refreshToken } from "helpers";
import { uiActions } from "store";

import styles from "./sessionExpiration.module.scss";

const FIVE_SECONDS = 5000;
//The modal controlled from modal manager
const SessionExpirationModal = ({ show, dialogAs, backdrop }) => {
	const dispatch = useDispatch();
	const logoutTimerRef = useRef();
	const history = useHistory();

	const handleHide = useCallback(() => {
		dispatch(uiActions.hideSessionExpirationModal());
	}, [dispatch]);

	const handleLogout = useCallback(() => {
		history.replace(URLS.logout);
	}, [history]);

	const handleYes = useCallback(() => {
		const currentUser = localStorage.getItem("user");
		const { refresh_token } = JSON.parse(currentUser);
		refreshToken(refresh_token)
			.catch(() => handleLogout())
			.finally(() => handleHide());
	}, [handleHide, handleLogout]);

	const checkIsLogOutRequired = useCallback(() => {
		const sessionExpired = isSessionExpired();
		const currentUser = localStorage.getItem("user");

		if (currentUser && sessionExpired) {
			handleLogout();
		}
	}, [handleLogout]);

	useLayoutEffect(() => {
		clearTimeout(logoutTimerRef.current);
		logoutTimerRef.current = setInterval(
			checkIsLogOutRequired,
			FIVE_SECONDS,
		);
		return () => {
			clearTimeout(logoutTimerRef.current);
		};
	}, [checkIsLogOutRequired]);

	return (
		<Modal
			className={styles.sessionExpirationModal}
			show={show}
			onHide={handleLogout}
			animation={false}
			centered
			dialogAs={dialogAs}
			backdrop={backdrop}
		>
			<Modal.Header className={styles.header}>
				Your session is about to expire in 5 minutes.
				<br />
				Need to stay in longer?
				<CloseButton onClick={handleLogout} />
			</Modal.Header>
			<Modal.Footer className={styles.footer}>
				<div className={styles.options}>
					<Button
						className={styles.no}
						onClick={handleLogout}
						value="No"
						variant="outline-primary"
					/>
					<Button
						className={styles.no}
						onClick={handleYes}
						value="Yes"
					/>
				</div>
			</Modal.Footer>
		</Modal>
	);
};

export { SessionExpirationModal };
